import React from "react";
import bg from "assests/contact/cbg.jpg";
import Container from "Components/Container/Container";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";
import {
  YoutubeLogo,
  FacebookLogo,
  LinkedinLogo,
  WhatsappLogo,
} from "@phosphor-icons/react";

const Hero = () => {
  const data = [
    {
      name: "let's talk",
      link_content: "+971 4 3468556",
      link: "https://wa.me/+97143468556",
    },
    {
      name: "Send us",
      link_content: "sales@martinpro-me.com",
      link: "mailto:sales@martinpro-me.com",
    },
    {
      name: "stay tuned",
      link: "",
      socialLinks: [
        {
          icon: <FacebookLogo size={24} />,
          url: "https://www.facebook.com/MartinProfessionalMiddleEast/",
          hoverColor: "hover:text-[#1877F2]", // Facebook brand color
        },
        {
          icon: <YoutubeLogo size={24} />,
          url: "https://www.youtube.com/channel/UCkLYcWRXEm2W-5QZa1pVDPw",
          hoverColor: "hover:text-[#FF0000]", // YouTube brand color
        },
        {
          icon: <LinkedinLogo size={24} />,
          url: "https://www.linkedin.com/company/martin-professional-middle-east/",
          hoverColor: "hover:text-[#0A66C2]", // LinkedIn brand color
        },
        {
          icon: <WhatsappLogo size={24} />,
          url: "https://wa.me/+97143468556",
          hoverColor: "hover:text-[#25D366]", // WhatsApp brand color
        },
      ],
    },
  ];

  return (
    <section
      className="scroll-section-special"
      style={{ backgroundImage: `url(${bg})` }}
    >
      <Container className="h-[100vh]">
        <div className="min-h-full flex flex-col items-center justify-center">
          <p className="text-2xl uppercase text-font mb-2">Contact us</p>
          <h1 className="title text-center">Contact info</h1>

          <div className="flex flex-col lg:flex-row lg:w-3/4 mx-auto gap-10 items-stretch justify-center mt-24">
            {data.map(({ name, link, socialLinks, link_content }, index) => (
              <div
                key={index}
                className="flex-1 flex gap-x-4 bg-[#00000096] hover:bg-black transition ease-in duration-300 text-white p-6 rounded-xl"
              >
                <div className="relative">
                  <ArrowUpRight size={28} />
                  <div className="absolute top-1/2 -translate-y-1/2 right-1.5 bg-red-300 h-1/2 mt-2 w-[1px]"></div>
                </div>
                <div>
                  <p className="text-2xl mb-3">{name}</p>
                  {socialLinks ? (
                    <div className="flex gap-4">
                      {socialLinks.map(({ icon, url, hoverColor }, idx) => (
                        <a
                          key={idx}
                          href={url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={`${hoverColor} transition-colors duration-300`}
                        >
                          {icon}
                        </a>
                      ))}
                    </div>
                  ) : (
                    <a href={link} className="text-lg hover:underline">
                      {link_content}
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Hero;
